<header class="page-header">
  <button
    *ngIf="showBack"
    type="button"
    class="page-header__back"
    (click)="back.emit()"
    [attr.aria-label]="backLabel"
    [title]="backLabel"
  >
    <i class="pi pi-arrow-left" aria-hidden="true"></i>
  </button>

  <span *ngIf="icon" class="page-header__icon" aria-hidden="true"><i [class]="icon"></i></span>

  <div class="page-header__text">
    <h1 class="page-header__title">{{ title }}</h1>
    <p *ngIf="subtitle" class="page-header__subtitle">{{ subtitle }}</p>
  </div>

  <div class="page-header__actions">
    <ng-content></ng-content>
  </div>
</header>
